'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ArrowRightIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ArrowRightIcon">
      <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.49998 0.333313L6.32498 1.50831L10.975 6.16665H0.833313V7.83331H10.975L6.32498 12.4916L7.49998 13.6666L14.1666 6.99998L7.49998 0.333313Z"
          fill={sx?.color || 'white'}
        />
      </svg>
    </SvgIcon>
  )
}

ArrowRightIcon.propTypes = {
  sx: PropTypes.object
}
